<!-- 公告弹框 -->
<template>
  <div v-if="$store.state.config.noVisitorTodo">
    <div class="master">
      <div class="pop-box">
        <div class="pop-con">
          <div class="close-btn pointer" v-if="closeBtn" @click="closeDialog"><img src="https://www.jinhanfair.com/static/home/images/close_btn.png" /></div>
          <div class="pop-logo">
            <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/logo.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: 'noticDialog',
  components: {},
  props: {
    // 弹框显示隐藏
    nShow: {
      type: Boolean,
      default: false
    },
    closeBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },

  computed: {
    dSHow() {
      return this.nShow
    }
  },

  watch: {},

  mounted() {},

  methods: {
    // 取消方法
    handleCancel() {
      if (typeof this.cancel === 'function') {
        this.cancel(() => {
          this.closeDialog()
        })
      } else {
        this.closeDialog()
      }
    },
    // 确认方法
    handleSure() {
      if (typeof this.sure === 'function') {
        this.sure(() => {
          this.closeDialog()
        })
      } else {
        this.closeDialog()
      }
    },
    // 弹框关闭
    closeDialog() {
      //this.$emit("update:nShow", false)
      this.$store.commit('setNoVisitorTodo', false)
    }
  }
}
</script>
<style lang="stylus" scoped>
.master {
    position: fixed;
    background-color: $color-black-45;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100000;
}

.pop-box {
    position: absolute;
    width: 650px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: $color-white;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 4px;
}
.pop-logo {
    img {
      height: 32px;
    }
}

.pop-content {
    padding: 40px;

    .pop-div {
      font-size: 15px;
      line-height: 1.555;

      & + .pop-div {
        margin-top: 20px;
      }
    }
}

.close-btn {
    position: absolute;
    width: 36px;
    height: 36px;
    right: -12px;
    top: -12px;
}
.pop-btn-box {
    text-align: center;
    display: flex;
    justify-content: center;
}
.link_btn {
    display: inline-block;
    width: 280px;
    height: 56px;
    line-height: 56px;
    color: #fff;
    background: #009140;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
    float: left;
}
</style>
